module.exports = __webpack_public_path__ + "img/header-icon-shop.5c77ecc0.svg";